import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of } from "rxjs";

export const levelExamQuestionsResolver: ResolveFn<any> = (route, state) => {
  const topic_slug = signal<string>(route.paramMap.get("topic") ?? "");
  const cur_slug = signal<string>(route.queryParamMap.get("cur_slug") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;

  return _httpClient.get(`${baseUrl}api/website/topics/${topic_slug()}/questions?curriclum_slug=${cur_slug()}`).pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading Topics data");
      return of(undefined);
    }),
  );;
};
